<template>
  <div class="page-footer font-small light-gray pt-4">
    <b-container class="small-padding">
      <b-row>
        <b-col cols="12" md="6">
          <a href="https://www.patreon.com/bePatron?u=6740160"><img src="../assets/become_a_patron_button.png" alt="Become a Patron!" width="250"/></a>
        </b-col>
        <b-col cols="12" md="6" class="text-right">
          <a href="https://www.facebook.com/NetDragonscom-228392063192/" class="social-logo"><img src="../assets/f_logo.png" alt="Facebook" width="32" height="32" /></a>
          <a href="https://twitter.com/VagabondsQuest" class="social-logo"><img src="../assets/t_logo.png" alt="Twitter" width="32" height="32" /></a>
          <a href="https://discord.gg/wErvM3f" class="social-logo2"><img src="../assets/d_logo.png" alt="Discord" width="40" height="40" /></a>
        </b-col>
      </b-row>
    </b-container>
    <div class="text-center dark-gray py-3">&copy; 2019 Copyright:
      <a href="https://netdragons.com/">NetDragons.com</a>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style scoped>
.social-logo {
  padding: 0.3em;
}
.social-logo2 {
  padding: 0.2em;
}
.small-padding {
  padding-bottom: 1.0em;
}
.light-gray {
  background-color: #333333;
}
.dark-gray {
  background-color: #111111;
}
</style>